export default "__VITE_ASSET__dwyBHbFy__"